import React, { FC } from "react";
import "./TypingIndicator.scss";

export interface Props {
}

const TypingIndicator: FC<Props> = (_) => {
    return (
        <div className="typing-indicator">
            <div className="typing-indicator-part"></div>
            <div className="typing-indicator-part"></div>
            <div className="typing-indicator-part"></div>
        </div>
    );
};

export default TypingIndicator;
